import * as React from "react";
import { Block } from "kanopi-components/Block";
import { BlockProps } from "baseui/block";
import { Img } from "kanopi-components/Image";
import { useStyletron } from "kanopi-components/theme/useStyletron";
import { useUnderBreakpoint } from "kanopi-components/useUnderBreakpoint";

{
  /* TODO: Create a universal Icon component which allows background shape/color/etc */
}
type TCoverSectionIconProps = {
  size?: BlockProps["width"];
  active?: boolean; // is this appropriately named?
  icon: string;
};

const CoverSectionIcon: React.FC<TCoverSectionIconProps> = ({ size, active, icon }) => {
  const isMobile = useUnderBreakpoint("medium");
  const [, theme] = useStyletron();
  return (
    <Block
      display="flex"
      width={size || (isMobile ? "60px" : "80px")}
      padding={isMobile ? "5px" : "9px"}
      borderRadius={theme.sizing.scale400}
      borderWidth={"1px"}
      borderColor={theme.colors.contentPrimary}
      backgroundColor={theme.colors.backgroundPrimary}
      color={theme.colors.contentPrimary}
      alignItems="center"
      justifyContent="center"
      $style={{ boxSizing: "border-box" }}
    >
      <Img src={icon} fluid />
    </Block>
  );
};

export { CoverSectionIcon };
